import {createBrowserRouter, RouterProvider, Navigate} from "react-router-dom";

import App from "pages/app";
import Home from "pages/home";
import Login from "pages/login";
import IdentificacaoForm from "pages/identificacao";
import PreOperatorioForm from "pages/preOperatorio";
import AnestesiaForm from "pages/anestesia";
import EscoresForm from "pages/escores";
import IncisaoForm from "pages/incisao";
import CirculacaoExtracorporeaForm from "pages/circulacaoExtracorporea";
import PosOperatorioForm from "pages/posOperatorio";
import ObitoForm from "pages/obito";
import CirurgiaForm from "pages/cirurgia";
import HemotransfusaoForm from "pages/hemotransfusao";
import Categoria from "pages/categorias";
import UserManagement from "pages/userManagement";
import InstitutionManagement from "pages/institutionManagement"; // Novo import para o gerenciamento de instituições

import Layout from "components/Layout";
import {LanguageProvider} from "context/LanguageContext";

const MainRouter = () => {
  const routeConfig = createBrowserRouter([
    { path: "/", element: <Navigate to="/login" /> },
    { path: "login", element: <Login /> },
    {
      path: "app",
      children: [
        { index: true, element: <App /> },
        {
          path: "user-management",
          element: (
            <Layout>
              <UserManagement />
            </Layout>
          ),
        },
        {
          path: "institution-management", // Novo caminho para o gerenciamento de instituições
          element: (
            <Layout>
              <InstitutionManagement />
            </Layout>
          ),
        },
        {
          path: "home",
          element: (
            <Layout>
              <Home />
            </Layout>
          ),
        },
        {
          path: "categoria/:id",
          element: (
            <Layout>
              <Categoria />
            </Layout>
          ),
        },
        {
          path: "form/identificacao/:id?", // Novo caminho para criação ou edição de identificação
          element: (
            <Layout>
              <IdentificacaoForm />
            </Layout>
          ),
        },
        {
          path: "form/pre-operatorio/:id?", // Novo caminho para criação ou edição de identificação
          element: (
            <Layout>
              <PreOperatorioForm />
            </Layout>
          ),
        },
        {
          path: "form/escores/:id?", // Novo caminho para criação ou edição de identificação
          element: (
            <Layout>
              <EscoresForm />
            </Layout>
          ),
        },
        {
          path: "form/anestesia/:id?", // Novo caminho para criação ou edição de identificação
          element: (
            <Layout>
              <AnestesiaForm />
            </Layout>
          ),
        },
        {
          path: "form/incisao/:id?", // Novo caminho para criação ou edição de identificação
          element: (
            <Layout>
              <IncisaoForm />
            </Layout>
          ),
        },
        {
          path: "form/circulacao-extracorporea/:id?", // Novo caminho para criação ou edição de identificação
          element: (
            <Layout>
              <CirculacaoExtracorporeaForm />
            </Layout>
          ),
        },
        {
          path: "form/pos-operatorio/:id?", // Novo caminho para criação ou edição de identificação
          element: (
            <Layout>
              <PosOperatorioForm />
            </Layout>
          ),
        },
        {
          path: "form/obito/:id?", // Novo caminho para criação ou edição de identificação
          element: (
            <Layout>
              <ObitoForm />
            </Layout>
          ),
        },
        {
          path: "form/hemotransfusao/:id?", // Novo caminho para criação ou edição de identificação
          element: (
            <Layout>
              <HemotransfusaoForm />
            </Layout>
          ),
        },
        {
          path: "form/cirurgia/:id?", // Novo caminho para criação ou edição de identificação
          element: (
            <Layout>
              <CirurgiaForm />
            </Layout>
          ),
        },
      ],
    },
  ]);

  return (
    <LanguageProvider>
      <RouterProvider router={routeConfig} />
    </LanguageProvider>
  );
}; 

export default MainRouter;
